import {useGenericInfiniteQuery} from "@/hooks/useQueryHooks";
import type {TCity} from "@/store/types";

export const MISC_KEYS = {
  mToken: ["/token/"],
  mTokenLogout: ["/token/logout/"],
  qCategoryList: ["/category/"],
  qCategoryListAdmin: ["/interest/"],
  qCityList: (params?: string) => [`/cities/?${params}`],
} as const;

export const useCityListQuery = ({params}: {params?: string}) =>
  useGenericInfiniteQuery<TCity>({
    queryKey: MISC_KEYS.qCityList(params),
  });
